import { createContext, useContext } from 'react'

import type { AssessmentProcessContextType } from '../types/assessmentProcess.types'

export const AssessmentProcessContext = createContext<AssessmentProcessContextType | undefined>(
  undefined
)

export const useAssessmentProcess = (): AssessmentProcessContextType => {
  const context = useContext(AssessmentProcessContext)
  if (!context) {
    throw new Error('useAssessmentProcess must be used within AssessmentProcessProvider')
  }
  return context
}
